import CrudTable, { TextField, TextArea } from './CrudTable';

export default function AdminFaqs() {
  return (
    <CrudTable
      table="faqs"
      title="FAQs"
      itemLabel="FAQ"
      defaults={{ question: '', answer: '', order_index: 0 }}
      columns={[
        { key: 'question', label: 'Question', className: 'col-span-8' },
        { key: 'order_index', label: 'Order', className: 'col-span-2' },
      ]}
      render={(it, set) => (
        <>
          <TextField label="Question" value={it.question} onChange={v => set({ ...it, question: v })} required />
          <TextArea label="Answer" value={it.answer} onChange={v => set({ ...it, answer: v })} />
          <TextField label="Order" type="number" value={it.order_index} onChange={v => set({ ...it, order_index: v })} />
        </>
      )}
    />
  );
}
